// gloss
export const applyBrandLinkColor = (linkColor: string | null | undefined) => {
  if (typeof document === 'undefined') return;

  if (linkColor) {
    document.documentElement.style.setProperty('--link-color', linkColor);
  } else {
    document.documentElement.style.removeProperty('--link-color');
  }
};
